"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePriceContext = exports.PriceContextProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * This provides the default configuration for the PriceContext
 */


var PriceContext = /*#__PURE__*/(0, _react.createContext)({
  locale: null,
  thousandSeparator: ',',
  decimalSeparator: '.',
  useSeparators: false,
  conversionRates: null // price context should have access to conversion rates for easy conversion in the components/widgets

});

var PriceContextProvider = function PriceContextProvider(_ref) {
  var children = _ref.children,
      config = _ref.config;
  return /*#__PURE__*/_react.default.createElement(PriceContext.Provider, {
    value: config
  }, children);
};

exports.PriceContextProvider = PriceContextProvider;

var usePriceContext = function usePriceContext() {
  var context = (0, _react.useContext)(PriceContext);

  if (context === undefined) {
    console.error('usePriceContext must be used within a PriceContextProvider with a required config props');
    return null;
  }

  return context;
};

exports.usePriceContext = usePriceContext;
PriceContextProvider.propTypes = {
  children: _propTypes.default.element.isRequired,
  config: _propTypes.default.string.isRequired
};